"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const ButtonStyles = styled_components_1.css `
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.primary};
  border: 1px solid transparent;
  font-size: ${(props) => props.theme.sizes.base};
  font-weight: 600;
  color: ${(props) => props.theme.colors.textOnPrimary};
  border-radius: 8px;
  height: 42px;
  padding: 0 ${(props) => props.theme.spacing.small};
  transition: opacity 0.12s ease-in-out;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    text-decoration: none;
  }

  ${(props) => props.alternate &&
    styled_components_1.css `
      background-color: ${(props) => props.theme.colors.actionAlternate};
      color: ${(props) => props.theme.colors.textPrimary};
    `}

  ${(props) => props.outlined &&
    styled_components_1.css `
      background-color: transparent;
      color: ${(props) => props.theme.colors.textPrimary};
      border: 1px solid ${(props) => props.theme.colors.border};

      ${props.inverted &&
        styled_components_1.css `
        color: ${(props) => props.theme.colors.textInvertedPrimary};
        border-color: ${(props) => props.theme.colors.textInvertedPrimary};
      `};

      ${props.onColor &&
        styled_components_1.css `
        color: ${(props) => props.theme.colors.textOnColor};
        border-color: ${(props) => props.theme.colors.textOnColor};
      `};
    `}

  ${(props) => props.disabled &&
    styled_components_1.css `
      opacity: 0.5;
      cursor: not-allowed;
    `}

  ${(props) => props.smaller &&
    styled_components_1.css `
      padding: 0 ${(props) => props.theme.spacing.xs};
      height: 30px;
    `};

  ${(props) => props.circular &&
    styled_components_1.css `
      height: 48px;
      width: 48px;
      padding: 0;
      border-radius: 50%;

      ${props.smaller &&
        styled_components_1.css `
        height: 30px;
        width: 30px;
      `};
    `};

  ${(props) => props.compensateSpace &&
    styled_components_1.css `
      margin: -40px 0;
    `}

  ${(props) => props.active &&
    styled_components_1.css `
      background-color: ${(props) => props.theme.colors.borderDim};
      border-color: ${(props) => props.theme.colors.border};
    `};

  svg,
  i {
    ${(props) => !props.circular &&
    styled_components_1.css `
        margin-right: ${(props) => props.theme.spacing.xs};
        margin-left: -${(props) => props.theme.spacing.xs};
      `}
  }

  i {
    ${(props) => !props.circular &&
    styled_components_1.css `
        margin-left: -7px;
      `}
  }
`;
exports.ButtonStyles = ButtonStyles;
const Button = styled_components_1.default.button `
  ${ButtonStyles}
`;
exports.Button = Button;
const ButtonList = styled_components_1.default.div `
  display: flex;
  align-items: ${(props) => props.alignItems || "center"};
  justify-content: flex-start;
  flex-direction: ${(props) => (props.vertical ? "column" : "row")};
  gap: ${(props) => (props.tight ? "4px" : props.theme.spacing.small)};

  ${(props) => props.align === "center" &&
    styled_components_1.css `
      justify-content: center;
    `}

  ${(props) => props.align === "right" &&
    styled_components_1.css `
      justify-content: flex-end;
    `}

  ${(props) => props.align === "stretch" &&
    styled_components_1.css `
      justify-content: stretch;
      align-items: initial;

      > * {
        flex: 1;
      }
    `}

  ${(props) => props.align === "space-between" &&
    styled_components_1.css `
      justify-content: space-between;
    `}

  ${(props) => props.gutterTop &&
    styled_components_1.css `
      margin-top: ${props.theme.spacing.medium};
    `}

  ${(props) => props.gutterBottom &&
    styled_components_1.css `
      margin-bottom: ${props.theme.spacing.medium};
    `}
`;
exports.ButtonList = ButtonList;
